import React, { useMemo } from "react";
import { ConnectButton } from "@rainbow-me/rainbowkit";
import { useNetwork } from "wagmi";
import { trimAddress } from "../hooks/constant";
import testnetLogo from "../images/testnet.png";
import mainnetLogo from "../images/mainnet.png";

const NETWORK_INFO = {
  24116: {
    name: "Rails Testnet",
    logo: testnetLogo,
  },
  6278: {
    name: "Rails Mainnet",
    logo: mainnetLogo,
  },
};

const buttonStyle = {
  background: "linear-gradient(91.96deg, #7be1be 24.05%, #4d8df3 95.41%)",
  color: "#0C0C12",
  fontWeight: 700,
  padding: "10px 28px",
  borderRadius: "5px",
  border: "none",
  cursor: "pointer",
  minWidth: "180px",
};

export default function Connect() {
  const { chain } = useNetwork();
  const networkId = chain?.id;
  const networkDetails = useMemo(() => NETWORK_INFO[networkId], [networkId]);

  return (
    <div className="d-flex justify-content-between align-items-center" style={{ gap: "20px" }}>
      <div className="d-flex align-items-center">
        {networkDetails?.logo && (
          <img
            src={networkDetails.logo}
            alt={networkDetails.name}
            width="50px"
            style={{ marginRight: "10px" }}
          />
        )}
        <span style={{ fontSize: "1.2rem", fontWeight: 600 }}>
          {networkDetails?.name || (chain ? chain.name : "Select Network")}
        </span>
      </div>

      <ConnectButton.Custom>
        {({
          account,
          mounted,
          openAccountModal,
          openConnectModal,
          openChainModal,
        }) => {
          const ready = mounted;
          const connected = ready && account;
          const label = connected
            ? trimAddress(account.displayName || account.address)
            : "Connect Wallet";

          const networkLabel =
            networkDetails?.name || (chain ? chain.name : "Select Network");

          const handleClick = () => {
            connected ? openAccountModal?.() : openConnectModal?.();
          };

          return (
            <div
              {...(!ready && {
                "aria-hidden": true,
                style: { opacity: 0.5, pointerEvents: "none" },
              })}
            >
              <div style={{ display: "flex", gap: "12px", alignItems: "center" }}>
                <button
                  type="button"
                  style={{
                    ...buttonStyle,
                    background: "#1f4a7d",
                    color: "#fafafa",
                    minWidth: "170px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    gap: "6px",
                  }}
                  onClick={() => openChainModal?.()}
                >
                  {networkLabel}
                  <span style={{ fontSize: "0.7em" }}>▾</span>
                </button>
                <button type="button" style={buttonStyle} onClick={handleClick}>
                  {label}
                </button>
              </div>
            </div>
          );
        }}
      </ConnectButton.Custom>
    </div>
  );
}
